export default __webpack_public_path__ + "static/media/Puzzle.6192c3ea.png";